import { render, staticRenderFns } from "./TodayEvent.vue?vue&type=template&id=8a0ac7de&scoped=true"
import script from "./TodayEvent.vue?vue&type=script&lang=js"
export * from "./TodayEvent.vue?vue&type=script&lang=js"
import style0 from "./TodayEvent.vue?vue&type=style&index=0&id=8a0ac7de&prod&lang=scss"
import style1 from "./TodayEvent.vue?vue&type=style&index=1&id=8a0ac7de&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a0ac7de",
  null
  
)

export default component.exports